import GameModel from "../../GameModel";
import BigNum from "../math/BigNum";
import GameTime from "../time/GameTime";
import ValuePerTurnCalculator from "./ValuePerTurnCalculator";

export default class Totals extends GameModel {
    /**
     * 
     * @param {GameTime} gameTime
     */
    constructor(gameTime) {
        super();

        /**
         * @constant
         * @type {ValuePerTurnCalculator}
         */
        this.oreRatePerTurnCalculator = new ValuePerTurnCalculator(gameTime, 20, 0.5);
        /**
         * @constant
         * @type {ValuePerTurnCalculator}
         */
        this.goldRatePerTurnCalculator = new ValuePerTurnCalculator(gameTime, 20, 0.5); 
        /**
         * @constant
         * @type {ValuePerTurnCalculator}
         */
        this.prestigeRatePerTurnCalculator = new ValuePerTurnCalculator(gameTime, 20, 0.5);
        /**
         * @constant
         * @type {ValuePerTurnCalculator}
         */
        this.rubyRatePerTurnCalculator = new ValuePerTurnCalculator(gameTime, 20, 0.5); 

        /**
         * @constant
         * @type {BigNum}
         */
        this.ore = new BigNum(0);

        /**
         * Gold is a globally scoped currency that does not reset on prestige.
         * @constant
         * @type {BigNum}
         */
        this.gold = new BigNum(0);

        /**
         * Ruby is a globally scoped currency that does not reset on prestige.
         * @constant
         * @type {BigNum}
         */
        this.ruby = new BigNum(0);

        /**
         * @constant
         * @type {BigNum}
         */
        this.prestige = new BigNum(0);
        /**
         * Tracks total prestige for the purposes of the damage bonus. Does not decrement when you buy skills.
         * @constant
         * @type {BigNum}
         */
        this.prestigePointsSum = new BigNum(0);

        /**
         * @constant
         * @type {BigNum}
         */
        this.unclaimedPrestige = new BigNum(0);


        /**
         * @constant
         * @type {BigNum}
         */
        this.working = new BigNum(0);

        /**
         * @constant
         * @type {BigNum}
         */
        this.prestigePerTurn = new BigNum(0);
        /**
         * @constant
         * @type {BigNum}
         */
        this.goldPerTurn = new BigNum(0);
        /**
         * @constant
         * @type {BigNum}
         */
        this.orePerTurn = new BigNum(0);
        /**
         * @constant
         * @type {BigNum}
         */
        this.rubyPerTurn = new BigNum(0);

        /**
         * The amount of prestige earned while offline that has not been claimed yet.
         * @constant
         * @type {BigNum}
         */
        this.offlinePrestige = new BigNum(0);
        /**
         * The amount of gold earned while offline that has not been claimed yet.
         * @constant
         * @type {BigNum}
         */
        this.offlineGold = new BigNum(0);
        /**
         * The amount of ore earned while offline that has not been claimed yet.
         * @constant
         * @type {BigNum}
         */
        this.offlineOre = new BigNum(0);
        /**
         * The amount of ore earned while offline that has not been claimed yet.
         * @constant
         * @type {BigNum}
         */
        this.offlineRuby = new BigNum(0);

        /**
         * @type {number}
         */
        this.offlineSeconds = 0;

        /**
         * @type {number}
         */
        this.countedOfflineSeconds = 0;

        /**
         * @constant
         * @type {BigNum}
         */
        this.one = new BigNum(1);
    }

    /**
     * @param {BigNum} ore 
     */
    incrementOre(ore) {
        this.ore.add(ore);
        this.oreRatePerTurnCalculator.add(ore, this.orePerTurn);
    }

    /**
     * @param {BigNum} ore 
     */
    decrementOre(ore) {
        this.ore.sub(ore);
        if (this.ore.lessThanZero()) {
            this.ore.setZero();
        }
    }

    /**
     * @param {BigNum} gold 
     */
    incrementGold(gold) {
        this.gold.add(gold);
        this.goldRatePerTurnCalculator.add(gold, this.goldPerTurn);
    }

    /**
     * @param {BigNum} gold 
     */
    decrementGold(gold) {
        this.gold.sub(gold);
        if (this.gold.lessThanZero()) {
            this.gold.setZero();
        }
    }

    /**
     * @param {BigNum} ruby 
     */
    incrementRuby(ruby) {
        this.ruby.add(ruby);
        this.rubyRatePerTurnCalculator.add(ruby, this.rubyPerTurn);
    }

    /**
     * @param {BigNum} prestige 
     */
    decrementPrestige(prestige) {
        this.prestige.sub(prestige);
        if (this.prestige.lessThanZero()) {
            this.prestige.setZero();
        }
    }


    onTerrainLayerUnlocked() {
        // The crew earns 1 prestige point per layer unlock.
        
        this.unclaimedPrestige.add(this.one);
    }

    /**
     * @param {BigNum} prestige 
     */
    incrementOfflinePrestige(prestige) {
        this.offlinePrestige.add(prestige);
    }
    /**
     * @param {BigNum} gold 
     */
    incrementOfflineGold(gold) {
        this.offlineGold.add(gold);
    }
    /**
     * @param {BigNum} ore 
     */
    incrementOfflineOre(ore) {
        this.offlineOre.add(ore);
    }
    /**
     * @param {BigNum} ruby 
     */
    incrementOfflineRuby(ruby) {
        this.offlineRuby.add(ruby);
    }

    // Moved to OfflineLogic so that we could update the statistics.

    // claimOfflineEarnings() {
    //     this.countedOfflineSeconds = 0;
        
    //     this.prestige.add(this.offlinePrestige);
    //     this.prestigePointsSum.add(this.offlinePrestige);
    //     this.offlinePrestige.setZero();

    //     this.gold.add(this.offlineGold);
    //     this.offlineGold.setZero();

    //     this.ore.add(this.offlineOre);
    //     this.offlineOre.setZero();
        
    //     this.ruby.add(this.offlineRuby);
    //     this.offlineRuby.setZero();
    // }

    onPrestige() {

        this.prestigeRatePerTurnCalculator.add(this.unclaimedPrestige, this.prestigePerTurn);

        // Copy all the unclaimed prestige over to prestige.
        this.prestige.add(this.unclaimedPrestige);
        this.prestigePointsSum.add(this.unclaimedPrestige);
        this.unclaimedPrestige.setZero();
    }

    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        this.prestige.setZero();
        this.prestigePointsSum.setZero();
        this.unclaimedPrestige.setZero();
        this.gold.setZero();
        this.ruby.setZero();

        // Earning rates
        this.orePerTurn.setZero();
        this.prestigePerTurn.setZero();
        this.goldPerTurn.setZero();
        this.rubyPerTurn.setZero();

        // Offline earnings - based on the rates.
        this.offlinePrestige.setZero();
        this.offlineGold.setZero();
        this.offlineOre.setZero();
        this.offlineRuby.setZero();

        this.oreRatePerTurnCalculator.resetFull();
        this.goldRatePerTurnCalculator.resetFull();
        this.prestigeRatePerTurnCalculator.resetFull();
        this.rubyRatePerTurnCalculator.resetFull();

        this.resetForPrestige();
    }

    /**
     * @override
     */
    resetForPrestige() {
        this.ore.setZero();

        // This just resets the start turn.
        this.oreRatePerTurnCalculator.resetForPrestige();
        this.goldRatePerTurnCalculator.resetForPrestige();
        this.prestigeRatePerTurnCalculator.resetForPrestige();
        this.rubyRatePerTurnCalculator.resetForPrestige();
    }
    
}